import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  // auth
  register: (body) => client.post("/auth/register", body).then((r) => r.data),
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  checkout: (lookup_key) => client.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data),
  paymentStatus: (sid) => client.get(`/payments/status/${sid}`).then((r) => r.data),
  googleSession: (session_id) => client.post("/auth/google/session", { session_id }).then((r) => r.data),
  myCredits: () => client.get("/credits/me").then((r) => r.data),
  // admin users & billing
  adminUsers: () => client.get("/admin/users").then((r) => r.data),
  adminUserLedger: (id) => client.get(`/admin/users/${id}/ledger`).then((r) => r.data),
  adminPatchUser: (id, body) => client.patch(`/admin/users/${id}`, body).then((r) => r.data),
  stats: () => client.get("/stats").then((r) => r.data),
  listAthletes: (params) => client.get("/athletes", { params }).then((r) => r.data),
  getAthlete: (id) => client.get(`/athletes/${id}`).then((r) => r.data),
  createAthlete: (body) => client.post("/athletes", body).then((r) => r.data),
  deleteAthlete: (id) => client.delete(`/athletes/${id}`).then((r) => r.data),
  getIntel: (id) => client.get(`/athletes/${id}/intel`).then((r) => r.data),
  athleteStock: (id) => client.get(`/athletes/${id}/stock`).then((r) => r.data),
  addNote: (id, text) => client.post(`/athletes/${id}/notes`, { text }).then((r) => r.data),
  deleteNote: (id, noteId) => client.delete(`/athletes/${id}/notes/${noteId}`).then((r) => r.data),
  discover: (id) => client.post(`/athletes/${id}/discover`).then((r) => r.data),
  regenBrief: (id) => client.post(`/athletes/${id}/brief`, {}, { timeout: 200000 }).then((r) => r.data),
  updateIntel: (id, status) => client.patch(`/intel/${id}`, { status }).then((r) => r.data),
  seedCpra: () => client.post("/seed/cpra").then((r) => r.data),
  seedPrca: () => client.post("/seed/prca", {}, { timeout: 120000 }).then((r) => r.data),
  seedWpra: () => client.post("/seed/wpra", {}, { timeout: 120000 }).then((r) => r.data),
  seedNra: () => client.post("/seed/nra", {}, { timeout: 120000 }).then((r) => r.data),
  briefsBackfill: () => client.post("/briefs/backfill").then((r) => r.data),
  briefsBackfillStatus: () => client.get("/briefs/backfill/status").then((r) => r.data),
  usageSummary: () => client.get("/usage/summary").then((r) => r.data),
  usageLog: (limit = 100) => client.get("/usage/log", { params: { limit } }).then((r) => r.data),
  scanAll: (only_unscanned, discipline = "", association = "") => client.post("/scan-all", null, { params: { only_unscanned, discipline, association } }).then((r) => r.data),
  stopScan: () => client.post("/scan-all/stop").then((r) => r.data),
  scanStatus: () => client.get("/scan-status").then((r) => r.data),
  scanAthletes: (athlete_ids) => client.post("/scan-athletes", { athlete_ids }).then((r) => r.data),
  updateDaily: (enabled) => client.put("/settings/daily", { enabled }).then((r) => r.data),
  presenterBuild: (body) => client.post("/presenter/build", body).then((r) => r.data),
  presenterDraw: (event, discipline) => client.get("/presenter/draw", { params: { event, discipline } }).then((r) => r.data),
  presenterExportDocx: (sheet) => client.post("/presenter/export-docx", sheet, { responseType: "blob" }).then((r) => r.data),
  mediaGuideImport: () => client.post("/media-guide/import", {}, { timeout: 120000 }).then((r) => r.data),
  // stock
  stockSeed: () => client.post("/stock/seed").then((r) => r.data),
  stockImportRodeopilot: () => client.post("/stock/import-rodeopilot", null, { timeout: 180000 }).then((r) => r.data),
  stockStats: () => client.get("/stock/stats").then((r) => r.data),
  listEvents: () => client.get("/events").then((r) => r.data),
  listContractors: (q = "") => client.get("/contractors", { params: { q } }).then((r) => r.data),
  getContractor: (id) => client.get(`/contractors/${id}`).then((r) => r.data),
  contractorIntel: (id) => client.get(`/contractors/${id}/intel`).then((r) => r.data),
  discoverContractor: (id) => client.post(`/contractors/${id}/discover`).then((r) => r.data),
  listAnimals: (params) => client.get("/animals", { params }).then((r) => r.data),
  getAnimal: (id) => client.get(`/animals/${id}`).then((r) => r.data),
  animalIntel: (id) => client.get(`/animals/${id}/intel`).then((r) => r.data),
  discoverAnimal: (id) => client.post(`/animals/${id}/discover`).then((r) => r.data),
  allAccounts: (pending) => client.get("/accounts", { params: { pending } }).then((r) => r.data),
  addAccount: (athleteId, body) => client.post(`/athletes/${athleteId}/accounts`, body).then((r) => r.data),
  updateAccount: (id, body) => client.patch(`/accounts/${id}`, body).then((r) => r.data),
  deleteAccount: (id) => client.delete(`/accounts/${id}`).then((r) => r.data),
  listSources: () => client.get("/sources").then((r) => r.data),
  createSource: (body) => client.post("/sources", body).then((r) => r.data),
  updateSource: (id, body) => client.patch(`/sources/${id}`, body).then((r) => r.data),
  deleteSource: (id) => client.delete(`/sources/${id}`).then((r) => r.data),
  getSettings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (enabled_platforms) => client.put("/settings", { enabled_platforms }).then((r) => r.data),
};
